module.exports = __webpack_public_path__ + "media/images/escudo_20180920_blanco-adb4dc0f7ce6a9a4e6488921b776fe10.svg";